module.exports = __webpack_public_path__ + "img/baemin.cd35ed12.png";